export const RANKED_ROLES = ["super-admin", "admin", "member"] as const;
export type KnownRole = (typeof RANKED_ROLES)[number];

const ROLE_RANK: Record<string, number> = {
  "super-admin": 0,
  admin: 1,
  member: 2,
};

export const ROLE_LABEL_KEY: Record<KnownRole, string> = {
  "super-admin": "LABEL_SUPER_ADMIN",
  admin: "LABEL_ADMIN",
  member: "LABEL_MEMBER",
};

type Membership = Readonly<{
  organizationId: string;
  roles?: readonly string[];
}>;

const normalizeRole = (role?: string | null) =>
  (role ?? "").toLowerCase().trim();

export const getOrgRoles = (
  memberships: ReadonlyArray<Membership> | undefined,
  orgId?: string,
): KnownRole[] => {
  const membership = memberships?.find((m) => m.organizationId === orgId);
  const roles = (membership?.roles ?? []).map(normalizeRole);
  return [...new Set(roles)]
    .filter((role): role is KnownRole => role in ROLE_RANK)
    .sort((a, b) => ROLE_RANK[a] - ROLE_RANK[b]);
};
